export default __webpack_public_path__ + "static/media/conference.34e55c2b.svg";